// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a1505d34","239":"f9d3ef09","455":"7c2466a6"}[chunkId] + ".chunk.js";
};